<template>
  <div class="flex gap-2 flex-wrap">
    {{ getAttributeFriendlyName }}
    <label
      v-for="refinement in refinementItem.refinements"
      :key="[refinement.attribute, refinement.value, refinement.operator].join(':')"
      @click="updateFilter(refinement)"
      class="inline-flex items-center rounded-full text-sm font-normal gap-2 px-2 py-1 non-italic w-max bg-gray-300 border border-gray-300 text-border-blue hover:bg-indigo-light hover:cursor-pointer capitalize"
    >
      {{ getLabel(refinement) }} <close-icon />
    </label>
  </div>
</template>
<script setup>
import { computed } from "vue";

import { useRegisteredFacets } from "../composables/useRegisteredFacets";

import { CloseIcon } from "@/components/shared/icons";

const props = defineProps({
  refinementItem: {
    type: Object,
  },
  createURL: {
    type: Function,
  },
  operator: {
    type: String,
    default: "or",
  },
  includeCounts: {
    type: Boolean,
    default: false,
  },
  includeAttribute: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["updateRefinement"]);

const { currentFacets } = useRegisteredFacets();

const getAttributeFriendlyName = computed(() => {
  const facet = currentFacets.value.find((facet) => facet.attribute === props.refinementItem.attribute);
  return props.includeAttribute && facet ? facet.title : "";
});

const updateFilter = (refinement) => {
  refinement["type"] = "disjunctive";
  emit("updateRefinement", refinement);
};

const getLabel = (refinement) => {
  const counts = props.includeCounts ? ` [${refinement?.count ?? 0}]` : "";
  return `${refinement.label}${counts}`;
};
</script>
